import { useRecoilValue } from "recoil";

import { SYSTEM_PARAMS_STORE_ROOT_SITE_ID } from "../constants";
import {
  isValidPositiveNumber,
  pickEffectiveSystemParamsFromCompanyStore,
} from "../helpers";
import type { FEAvailableSystemParamMetadata } from "../models";
import { systemSettingsDtoAtom } from "../recoil";
import { useSystemParams } from "./use-system-params";

export const useSystemParamsForSite = (
  siteId?: number | null,
): FEAvailableSystemParamMetadata => {
  const generalParams = useSystemParams();
  const systemSettingsDto = useRecoilValue(systemSettingsDtoAtom);
  const companyWideParams =
    systemSettingsDto?.paramsBySite?.[SYSTEM_PARAMS_STORE_ROOT_SITE_ID] ??
    generalParams;

  if (!isValidPositiveNumber(siteId)) {
    return generalParams;
  }

  return (
    pickEffectiveSystemParamsFromCompanyStore({
      companyParams: companyWideParams,
      paramsBySite: systemSettingsDto?.paramsBySite,
      siteId,
    }) ?? companyWideParams
  );
};
